import { TFunction } from "i18next";

import { Color, ColorType } from "../theme";

export enum AcceptenceCriteriaColors {
  NotAcceptable = Color.red,
  Acceptable = Color.green,
  Invalid = Color.text2,
}

export interface Tempature {
  value: string;
  label: string;
  color: Color | ColorType | AcceptenceCriteriaColors;
}

export const freezerTemperatures = [
  {
    value: "100",
    label: "> -12,5 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-12.5",
    label: "-12,5 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-13",
    label: "-13,0 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-13.5",
    label: "-13,5 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-14",
    label: "-14,0 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-14.5",
    label: "-14,5 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-15",
    label: "-15,0 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-15.5",
    label: "-15,5 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-16",
    label: "-16,0 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-16.5",
    label: "-16,5 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-17",
    label: "-17,0 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-17.5",
    label: "-17,5 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-18",
    label: "-18,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-18.5",
    label: "-18,5 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-19",
    label: "-19,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-19.5",
    label: "-19,5 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-20",
    label: "-20,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-20.5",
    label: "-20,5 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-21",
    label: "-21,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-21.5",
    label: "-21,5 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-22",
    label: "-22,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-22.5",
    label: "-22,5 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-23",
    label: "-23,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-23.5",
    label: "-23,5 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-24",
    label: "-24,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-24.5",
    label: "-24,5 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-25",
    label: "-25,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-100",
    label: "< -25,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-101",
    label: "Fryseren er slukket",
    color: AcceptenceCriteriaColors.Acceptable,
  },
];
export const coolersTemperatures = [
  {
    value: "100",
    label: "Køleenheden er slukket",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "99",
    label: "> +10,0 ºC",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "10",
    label: "+10,0 ºC",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "9.5",
    label: "+9,5 ºC",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "9",
    label: "+9,0 ºC",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "8.5",
    label: "+8,5 ºC",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "8",
    label: "+8,0 ºC",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "7.5",
    label: "+7,5 ºC",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "7",
    label: "+7,0 ºC",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "6.5",
    label: "+6,5 ºC",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "6",
    label: "+6,0 ºC",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "5.5",
    label: "+5,5 ºC",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "5",
    label: "+5,0 ºC",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "4.5",
    label: "+4,5 ºC",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "4",
    label: "+4,0 ºC",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "3.5",
    label: "+3,5 ºC",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "3",
    label: "+3,0 ºC",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "+2.5",
    label: "+2,5 ºC",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "2",
    label: "+2,0 ºC",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "1.5",
    label: "+1,5 ºC",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "1",
    label: "+1,0 ºC",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "0.5",
    label: "+0,5 ºC",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  { value: "0", label: "0,0 ºC", color: AcceptenceCriteriaColors.Acceptable },
  {
    value: "-0.5",
    label: "-0,5 ºC",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-1",
    label: "-1,0 ºC",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-1.5",
    label: "-1,5 ºC",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-2",
    label: "-2,0 ºC",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-100",
    label: "< -2,0 ºC",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
];
export const fishCoolerTemperatures = [
  {
    value: "100",
    label: "> +7 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "7",
    label: "+7 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "6.5",
    label: "+6,5 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "6",
    label: "+6,0 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "5.5",
    label: "+5,5 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "5",
    label: "+5,0 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "4.5",
    label: "+4,5 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "4",
    label: "+4,0 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "3.5",
    label: "+3,5 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "3",
    label: "+3,0 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "2.5",
    label: "+2,5 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "2",
    label: "+2,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "1.5",
    label: "+1,5 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "1",
    label: "+1,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "0.5",
    label: "+0,5 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "0",
    label: "0,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-0.5",
    label: "-0,5 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-1",
    label: "-1,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-1.5",
    label: "-1,5 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-2",
    label: "-2,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-99",
    label: "< -2,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-101",
    label: "Fryseren er slukket",
    color: AcceptenceCriteriaColors.Acceptable,
  },
];
export const heatTreatmentTemperatures = [
  {
    value: "100",
    label: "> +80 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  { value: "80", label: "+80 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "79", label: "+79 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "78", label: "+78 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "77", label: "+77 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "76", label: "+76 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "75", label: "+75 °C", color: AcceptenceCriteriaColors.Acceptable },
  {
    value: "74",
    label: "+74 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "73",
    label: "+73 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "72",
    label: "+72 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "71",
    label: "+71 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-100",
    label: "< +70 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
];
export const heatRetentionTemperatures = [
  {
    value: "100",
    label: "> +70 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  { value: "70", label: "+70 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "69", label: "+69 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "68", label: "+68 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "67", label: "+67 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "66", label: "+66 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "65", label: "+65 °C", color: AcceptenceCriteriaColors.Acceptable },
  {
    value: "64",
    label: "+64 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "63",
    label: "+63 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "62",
    label: "+62 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "61",
    label: "+61 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-100",
    label: "< +60 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
];
export const dishwasherTemperatures = [
  {
    value: "100",
    label: "> +85 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  { value: "85", label: "+85 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "84", label: "+84 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "83", label: "+83 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "82", label: "+82 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "81", label: "+81 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "80", label: "+80 °C", color: AcceptenceCriteriaColors.Acceptable },
  {
    value: "79",
    label: "+79 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "78",
    label: "+78 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "77",
    label: "+77 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "76",
    label: "+76 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "75",
    label: "+75 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-100",
    label: "< +75 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
];

export const goodsTemperaturesFrost = [
  {
    value: "100",
    label: "> -12,5 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-12.5",
    label: "-12,5 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-13",
    label: "-13,0 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-13.5",
    label: "-13,5 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-14",
    label: "-14,0 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-14.5",
    label: "-14,5 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-15",
    label: "-15,0 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-15.5",
    label: "-15,5 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-16",
    label: "-16,0 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-16.5",
    label: "-16,5 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-17",
    label: "-17,0 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-17.5",
    label: "-17,5 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-18",
    label: "-18,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-18.5",
    label: "-18,5 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-19",
    label: "-19,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-19.5",
    label: "-19,5 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-20",
    label: "-20,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-20.5",
    label: "-20,5 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-21",
    label: "-21,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-21.5",
    label: "-21,5 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-22",
    label: "-22,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-22.5",
    label: "-22,5 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-23",
    label: "-23,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-23.5",
    label: "-23,5 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-24",
    label: "-24,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-24.5",
    label: "-24,5 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-25",
    label: "-25,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-25.5",
    label: "-25,5 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-26",
    label: "-26,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-26.5",
    label: "-26,5 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-27",
    label: "-27,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-27.5",
    label: "-27,5 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-28",
    label: "-28,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "-100",
    label: "< -28,0 °C",
    color: AcceptenceCriteriaColors.Acceptable,
  },
];
export const goodsTemperaturesCool = [
  {
    value: "21",
    label: "+21 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "20",
    label: "+20 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "19",
    label: "+19 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "18",
    label: "+18 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "17",
    label: "+17 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "16",
    label: "+16 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "15",
    label: "+15 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "14",
    label: "+14 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "13",
    label: "+13 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "12",
    label: "+12 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "11",
    label: "+11 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "10",
    label: "+10 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "9",
    label: "+9 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "8",
    label: "+8 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "7",
    label: "+7 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "6",
    label: "+6 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  { value: "5", label: "+5 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "4", label: "+4 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "3", label: "+3 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "2", label: "+2 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "1", label: "+1 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "0", label: "0 °C", color: AcceptenceCriteriaColors.Acceptable },
  {
    value: "-1",
    label: "-1 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-2",
    label: "-2 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-3",
    label: "-3 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-4",
    label: "-4 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-5",
    label: "-5 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-6",
    label: "-6 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-7",
    label: "-7 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-8",
    label: "-8 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-9",
    label: "-9 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-10",
    label: "-10 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
];
export const goodsTemperaturesFish = [
  {
    value: "10",
    label: "+10 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "9",
    label: "+9 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "8",
    label: "+8 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "7",
    label: "+7 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "6",
    label: "+6 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "5",
    label: "+5 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "4",
    label: "+4 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "3",
    label: "+3 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  { value: "2", label: "+2 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "1", label: "+1 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "0", label: "0 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "-1", label: "-1 °C", color: AcceptenceCriteriaColors.Acceptable },
  { value: "-2", label: "-2 °C", color: AcceptenceCriteriaColors.Acceptable },
  {
    value: "-3",
    label: "-3 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-4",
    label: "-4 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-5",
    label: "-5 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-6",
    label: "-6 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-7",
    label: "-7 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-8",
    label: "-8 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-9",
    label: "-9 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
  {
    value: "-10",
    label: "-10 °C",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
];

export const goodsTemperaturesDryFood = (t: TFunction<"ns1", undefined>) => [
  {
    value: "-105",
    label: t("food.Dry Food Option Label"),
    color: AcceptenceCriteriaColors.Invalid,
  },
];

export const floorCleaningValues = [
  {
    value: "1",
    label: "Rengøringen er udført",
    color: AcceptenceCriteriaColors.Acceptable,
  },
  {
    value: "2",
    label: "Rengøringen er udført, men med mangler",
    color: "rgb(255, 179, 0)",
  },
  {
    value: "3",
    label: "Rengøringen er ikke udført",
    color: AcceptenceCriteriaColors.NotAcceptable,
  },
];

export const heatingGuidelines = {
  meat: [
    { temp: 56, message: "Minimumskrav til holdetid: 140 min. ved 56°C" },
    { temp: 57, message: "Minimumskrav til holdetid: 99 min. ved 57°C" },
    { temp: 58, message: "Minimumskrav til holdetid: 70 min. ved 58°C" },
    { temp: 59, message: "Minimumskrav til holdetid: 49 min. ved 59°C" },
    { temp: 60, message: "Minimumskrav til holdetid: 35 min. ved 60" },
    { temp: 61, message: "Minimumskrav til holdetid: 25 min. ved 61°C" },
    { temp: 62, message: "Minimumskrav til holdetid: 17 min. ved 62°C" },
    { temp: 63, message: "Minimumskrav til holdetid: 12 min. ved 63°C" },
    { temp: 64, message: "Minimumskrav til holdetid: 9 min. ved 64°C" },
    { temp: 65, message: "Minimumskrav til holdetid: 6 min. ved 65°C" },
    { temp: 66, message: "Minimumskrav til holdetid: 4 min. ved 66°C" },
    { temp: 67, message: "Minimumskrav til holdetid: 3 min. ved 67°C" },
    { temp: 68, message: "Minimumskrav til holdetid: 2 min. ved 68°C" },
    { temp: 69, message: "Minimumskrav til holdetid: 2 min. ved 69°C" },
    { temp: 70, message: "Minimumskrav til holdetid: 1 min. ved 70°C" },
    { temp: 71, message: "Minimumskrav til holdetid: 45 sekunder ved 71°C" },
    { temp: 72, message: "Minimumskrav til holdetid: 32 sekunder ved 72°C" },
    { temp: 73, message: "Minimumskrav til holdetid: 22 sekunder ved 73°C" },
    { temp: 74, message: "Minimumskrav til holdetid: 16 sekunder ved 74°C" },
    { temp: 75, message: "Minimumskrav til holdetid: 11 sekunder ved 75°C" },
    { temp: 76, message: "Minimumskrav til holdetid: 8 sekunder ved 76°C" },
    { temp: 77, message: "Minimumskrav til holdetid: 6 sekunder ved 77°C" },
    { temp: 78, message: "Minimumskrav til holdetid: 4 sekunder ved 78°C" },
    { temp: 79, message: "Minimumskrav til holdetid: 3 sekunder ved 79°C" },
    { temp: 80, message: "Minimumskrav til holdetid: 2 sekunder ved 80°C" },
    { temp: 81, message: "Minimumskrav til holdetid: 1 sekunder ved 81°C" },
    { temp: 82, message: "Minimumskrav til holdetid: 1 sekunder ved 82°C" },
    { temp: 83, message: "Minimumskrav til holdetid: 1 sekunder ved 83°C" },
    { temp: 84, message: "Minimumskrav til holdetid: 0 sekunder ved 84°C" },
  ],
  fish: [
    { temp: 56, message: "Minimumskrav til holdetid: 51 min. ved 56°C" },
    { temp: 57, message: "Minimumskrav til holdetid: 35 min. ved 57°C" },
    { temp: 58, message: "Minimumskrav til holdetid: 25 min. ved 58°C" },
    { temp: 59, message: "Minimumskrav til holdetid: 17 min. ved 59°C" },
    { temp: 60, message: "Minimumskrav til holdetid: 12 min. ved 60°C" },
    { temp: 61, message: "Minimumskrav til holdetid: 8 min. ved 61°C" },
    { temp: 62, message: "Minimumskrav til holdetid: 5 min. ved 62°C" },
    { temp: 63, message: "Minimumskrav til holdetid: 4 min. ved 63°C" },
    { temp: 64, message: "Minimumskrav til holdetid: 3 min. ved 64°C" },
    { temp: 65, message: "Minimumskrav til holdetid: 2 min. ved 65°C" },
    { temp: 66, message: "Minimumskrav til holdetid: 1 min. ved 66°C" },
    { temp: 67, message: "Minimumskrav til holdetid: 51 sekunder ved 67°C" },
    { temp: 68, message: "Minimumskrav til holdetid: 35 sekunder ved 68°C" },
    { temp: 69, message: "Minimumskrav til holdetid: 24 sekunder ved 69°C" },
    { temp: 70, message: "Minimumskrav til holdetid: 17 sekunder ved 70°C" },
    { temp: 71, message: "Minimumskrav til holdetid: 12 sekunder ved 71°C" },
    { temp: 72, message: "Minimumskrav til holdetid: 8 sekunder ved 72°C" },
    { temp: 73, message: "Minimumskrav til holdetid: 6 sekunder ved 73°C" },
    { temp: 74, message: "Minimumskrav til holdetid: 4 sekunder ved 74°C" },
    { temp: 75, message: "Minimumskrav til holdetid: 3 sekunder ved 75°C" },
    { temp: 76, message: "Minimumskrav til holdetid: 2 sekunder ved 76°C" },
    { temp: 77, message: "Minimumskrav til holdetid: 1 sekunder ved 77°C" },
    { temp: 78, message: "Minimumskrav til holdetid: 1 sekunder ved 78°C" },
    { temp: 79, message: "Minimumskrav til holdetid: 1 sekunder ved 79°C" },
  ],
  vegetables: [
    { temp: 58, message: "Minimumskrav til holdetid: 0 min. ved 58°C" },
    { temp: 59, message: "Minimumskrav til holdetid: 0 min. ved 59°C" },
    { temp: 60, message: "Minimumskrav til holdetid: 31 min. ved 60°C" },
    { temp: 61, message: "Minimumskrav til holdetid: 22 min. ved 61°C" },
    { temp: 62, message: "Minimumskrav til holdetid: 16 min. ved 62°C" },
    { temp: 63, message: "Minimumskrav til holdetid: 11 min. ved 63°C" },
    { temp: 64, message: "Minimumskrav til holdetid: 8 min. ved 64°C" },
    { temp: 65, message: "Minimumskrav til holdetid: 6 min. ved 65°C" },
    { temp: 66, message: "Minimumskrav til holdetid: 4 min. ved 66°C" },
    { temp: 67, message: "Minimumskrav til holdetid: 3 min. ved 67°C" },
    { temp: 68, message: "Minimumskrav til holdetid: 2 min. ved 68°C" },
    { temp: 69, message: "Minimumskrav til holdetid: 1 min. ved 69°C" },
    { temp: 70, message: "Minimumskrav til holdetid: 1 min. ved 70°C" },
    { temp: 71, message: "Minimumskrav til holdetid: 43 sekunder ved 71°C" },
    { temp: 72, message: "Minimumskrav til holdetid: 30 sekunder ved 72°C" },
    { temp: 73, message: "Minimumskrav til holdetid: 21 sekunder ved 73°C" },
    { temp: 74, message: "Minimumskrav til holdetid: 15 sekunder ved 74°C" },
    { temp: 75, message: "Minimumskrav til holdetid: 11 sekunder ved 75°C" },
    { temp: 76, message: "Minimumskrav til holdetid: 8 sekunder ved 76°C" },
    { temp: 77, message: "Minimumskrav til holdetid: 5 sekunder ved 77°C" },
    { temp: 78, message: "Minimumskrav til holdetid: 4 sekunder ved 78°C" },
    { temp: 79, message: "Minimumskrav til holdetid: 3 sekunder ved 79°C" },
    { temp: 80, message: "Minimumskrav til holdetid: 2 sekunder ved 80°C" },
    { temp: 81, message: "Minimumskrav til holdetid: 1 sekunder ved 81°C" },
    { temp: 82, message: "Minimumskrav til holdetid: 1 sekunder ved 82°C" },
    { temp: 83, message: "Minimumskrav til holdetid: 1 sekunder ved 83°C" },
    { temp: 84, message: "Minimumskrav til holdetid: 0 sekunder ved 84°C" },
  ],
  others: [
    { temp: 58, message: "Minimumskrav til holdetid: 0 min. ved 58°C" },
    { temp: 59, message: "Minimumskrav til holdetid: 0 min. ved 59°C" },
    { temp: 60, message: "Minimumskrav til holdetid: 28 min. ved 60°C" },
    { temp: 61, message: "Minimumskrav til holdetid: 20 min. ved 61°C" },
    { temp: 62, message: "Minimumskrav til holdetid: 15 min. ved 62°C" },
    { temp: 63, message: "Minimumskrav til holdetid: 10 min. ved 63°C" },
    { temp: 64, message: "Minimumskrav til holdetid: 8 min. ved 64°C" },
    { temp: 65, message: "Minimumskrav til holdetid: 5 min. ved 65°C" },
    { temp: 66, message: "Minimumskrav til holdetid: 4 min. ved 66°C" },
    { temp: 67, message: "Minimumskrav til holdetid: 3 min. ved 67°C" },
    { temp: 68, message: "Minimumskrav til holdetid: 2 min. ved 68°C" },
    { temp: 69, message: "Minimumskrav til holdetid: 1 min. ved 69°C" },
    { temp: 70, message: "Minimumskrav til holdetid: 1 min. ved 70°C" },
    { temp: 71, message: "Minimumskrav til holdetid: 45 sekunder ved 71°C" },
    { temp: 72, message: "Minimumskrav til holdetid: 32 sekunder ved 72°C" },
    { temp: 73, message: "Minimumskrav til holdetid: 23 sekunder ved 73°C" },
    { temp: 74, message: "Minimumskrav til holdetid: 17 sekunder ved 74°C" },
    { temp: 75, message: "Minimumskrav til holdetid: 12 sekunder ved 75°C" },
    { temp: 76, message: "Minimumskrav til holdetid: 9 sekunder ved 76°C" },
    { temp: 77, message: "Minimumskrav til holdetid: 6 sekunder ved 77°C" },
    { temp: 78, message: "Minimumskrav til holdetid: 5 sekunder ved 78°C" },
    { temp: 79, message: "Minimumskrav til holdetid: 3 sekunder ved 79°C" },
    { temp: 80, message: "Minimumskrav til holdetid: 2 sekunder ved 80°C" },
    { temp: 81, message: "Minimumskrav til holdetid: 2 sekunder ved 81°C" },
    { temp: 82, message: "Minimumskrav til holdetid: 1 sekunder ved 82°C" },
    { temp: 83, message: "Minimumskrav til holdetid: 1 sekunder ved 83°C" },
    { temp: 84, message: "Minimumskrav til holdetid: 1 sekunder ved 84°C" },
    { temp: 85, message: "Minimumskrav til holdetid: 0 sekunder ved 85°C" },
  ],
};
